<div class="gw-space-y-6 gw-p-x-large gw-max-w-lg">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <!-- Single string value -->
    <ng-container *ngIf="!isObjectValue">
      <div class="gw-space-y-4">
        <p class="gw-text-text-primary gw-text-base">
          {{
            'features.settings.parameters.' + setting.key + '.description'
              | translate
          }}
        </p>
        <gatewee-input-v2
          [form]="formGroup"
          controlName="value"
          [label]="
            ('features.settings.parameters.' + setting.key + '.label'
              | translate) || setting.key
          "
          [placeholder]="
            ('features.settings.parameters.' + setting.key + '.placeholder'
              | translate) || ''
          "
          [id]="'string-parameter-' + setting.key + '-value'"
          type="text"
          [required]="true"
        ></gatewee-input-v2>
      </div>
    </ng-container>

    <!-- Object of strings -->
    <ng-container *ngIf="isObjectValue">
      <div class="gw-space-y-4">
        <p class="gw-text-text-primary gw-text-base">
          {{
            'features.settings.parameters.' + setting.key + '.description'
              | translate
          }}
        </p>
        <div class="gw-space-y-4">
          <ng-container *ngFor="let key of stringKeys">
            <gatewee-input-v2
              [form]="formGroup"
              [controlName]="key"
              [label]="getSettingLabel(key) || key"
              [placeholder]="getSettingPlaceholder(key)"
              [id]="'string-parameter-' + setting.key + '-' + key"
              type="text"
            ></gatewee-input-v2>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
